import { columnTextField } from "utils/tables-utils";
import {
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Chip,
} from "@material-ui/core";
import TableComponent from "components/_refactor/table/table";

import { Create, Add } from "@mui/icons-material";
import { Button } from "@material-ui/core";

const STATUS_COLOR = {
  RASCUNHO: "default",
  AGENDADO: "primary",
  PARCIALMENTE_PUBLICADO: "primary",
  PUBLICADO: "secondary",
};

const STATUS_LABEL = {
  RASCUNHO: "Rascunho",
  AGENDADO: "Agendado",
  PARCIALMENTE_PUBLICADO: "Parcialmente publicado",
  PUBLICADO: "Publicado",
};

export default function TableNotasAtualizacao({
  dataTable,
  toggleFormDialog,
  setSelectedNota,
  searching,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Versao",
      text: "Versão",
      sort: false,
      align: "center",
    }),
    columnTextField({
      dataField: "Titulo",
      text: "Título",
      sort: false,
      align: "center",
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      sort: false,
      align: "center",
      formatter: (status) => (
        <Chip
          label={STATUS_LABEL[status] || status}
          color={STATUS_COLOR[status] || "default"}
          size="small"
        />
      ),
    }),
    columnTextField({
      dataField: "DataPublicacaoAndroid",
      text: "Play Store",
      sort: false,
      align: "center",
      formatter: (data, row) =>
        row.PublicarAndroid ? data || "Pendente" : "—",
    }),
    columnTextField({
      dataField: "DataPublicacaoIos",
      text: "App Store",
      sort: false,
      align: "center",
      formatter: (data, row) => (row.PublicarIos ? data || "Pendente" : "—"),
    }),
    columnTextField({
      dataField: "editar",
      text: "",
      align: "center",
      formatter: (_, row) =>
        searching ? null : (
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedNota(row);
                toggleFormDialog("edit");
              }}
            >
              <Create size="small" />
            </IconButton>
          </Tooltip>
        ),
    }),
  ];

  return (
    <Card>
      <CardContent>
        <TableComponent
          searched={Boolean(dataTable)}
          keyField="IdNotaAtualizacao"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Notas de Atualização"
          loading={searching}
          allowEmpty
          noResultTitle="Nenhuma nota de atualização cadastrada."
          noResultSubtitle="Clique em 'Nova nota' para começar."
          extraActions={
            <Button
              variant="contained"
              onClick={() => {
                setSelectedNota(null);
                toggleFormDialog("create");
              }}
              disabled={searching}
            >
              <Add /> Nova nota
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
